import React, { FC, MouseEvent } from 'react';
import classNames from 'classnames';

import { fc } from 'i18n';
import Checkbox from 'core/react/general/form/Checkbox';

import styles from './styles.module.css';

interface ISelectOptionProps {
  isSelected: boolean;
  id: string;
  name: string;
  onSelect: (id: string) => (event: MouseEvent<HTMLDivElement>) => void;
}

export const Option: FC<ISelectOptionProps> = ({ isSelected, id, name, onSelect }) => {
  const optionClassname = classNames(styles.option, { [styles.selected]: isSelected });

  return (
    <div className={optionClassname} onClick={onSelect(id)}>
      <Checkbox value={isSelected} inline={true} />
      <div className={styles.text}>{fc(name)}</div>
    </div>
  );
};
